// MailTo.jsx

/*
  PWA mailto solution:
  https://stackoverflow.com/questions/55610036/is-there-a-way-to-use-the-mailto-or-message-scheme-in-a-pwa-in-ios-12-2
*/

'use strict';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class MailTo extends PureComponent {
  handleClick = e => {
    const {
      subject,
      shouldFallbackToCustomerService,
      isUserInfoRequired,
      hasCustomerServiceToken,
      hasClientId,
      submitEmailToSupport,
      sendCurrentRemoteConfig,
      shouldBypassMailTo,
    } = this.props;
    const isCustomerServiceAlive = window?.Intercom?.booted || window.zE; // intercom || zendesk
    try {
      if (shouldBypassMailTo) return;

      if (shouldFallbackToCustomerService && isCustomerServiceAlive) {
        if (isUserInfoRequired) {
          if (!hasCustomerServiceToken)
            throw new Error(
              'Either Intercom User Hash or Zendesk User Token is Required.'
            );
          if (!hasClientId) throw new Error('Client Id is Required.');
        }
      } else {
        throw new Error('Customer service is shutdown');
      }
    } catch (err) {
      e.preventDefault();
      submitEmailToSupport({ subject });
      sendCurrentRemoteConfig();
    }
  };

  render() {
    const { children, ...rest } = this.props;
    return (
      <StyledMailTo {...rest} onClick={this.handleClick}>
        {children}
      </StyledMailTo>
    );
  }
}

MailTo.propTypes = {
  children: PropTypes.node,
  subject: PropTypes.string,
  shouldBypassMailTo: PropTypes.bool,
  shouldFallbackToCustomerService: PropTypes.bool,
  isUserInfoRequired: PropTypes.bool,
  hasCustomerServiceToken: PropTypes.bool,
  hasClientId: PropTypes.bool,
  submitEmailToSupport: PropTypes.func,
  sendCurrentRemoteConfig: PropTypes.func,
};

MailTo.defaultProps = {
  subject: '',
  shouldBypassMailTo: false,
  shouldFallbackToCustomerService: false,
  isUserInfoRequired: false,
  hasClientId: false,
  submitEmailToSupport: () => null,
  sendCurrentRemoteConfig: () => null,
};

const StyledMailTo = styled.button`
  cursor: pointer;
  outline: none;
  border: none;
  color: inherit;
  padding: 0;
  margin: 0;
  background-color: transparent;
`;

export default MailTo;
